var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ws-landing',{attrs:{"headline":"E-commerce fulfillment center in UAE","points":[
    'No long-term agreement',
    'Pick, pack, label and delivery',
    'E-commerce, B2B, B2C fulfillment' ],"image":require('../../assets/landing/landing2.webp'),"form-title":"Request a quote right now","bottom-line":"Easy, On-Demand Warehousing and fulfillment"}})}
var staticRenderFns = []

export { render, staticRenderFns }